import type { SVGProps } from 'react';

const SvgCricleCheckMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinejoin='round'
    />
    <path d='M9 12L11 14L15 10' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
export default SvgCricleCheckMd;
